export default __webpack_public_path__ + "static/media/card_2@2x.07319ef6.png";